import { render, staticRenderFns } from "./QuestionMatrixBlank.vue?vue&type=template&id=685f9c0c&scoped=true&"
import script from "./QuestionMatrixBlank.vue?vue&type=script&lang=js&"
export * from "./QuestionMatrixBlank.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMatrixBlank.vue?vue&type=style&index=0&id=685f9c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f9c0c",
  null
  
)

export default component.exports